
import Dashboard from "views/Dashboard.js";
import Notifications from "views/Notifications.js";
import TableList from "views/Tables.js"; 
import UserPage from "views/User.js";


var routes = [
  {
    path: "/dashboard",
    name: "Home",
    icon: "hc-icon home-outline tran-jagg",
    component: <Dashboard />,
    layout: "/user",
  },
  {
    path: "/tables",
    name: "Transactions",
    icon: "nc-icon nc-chart-pie-36 tran-jagg",
    component: <TableList />,
    layout: "/user",
  },
  {
    path: "/user-page",
    name: "Profile",
    icon: "nc-icon nc-single-02 tran-jagg",
    component: <UserPage />,
    layout: "/user",
  },
  {
    path: "/notifications",
    name: "help and support",
    icon: "nc-icon nc-bell-55 tran-jagg",
    component: <Notifications />,
    layout: "/user",
  }
];
export default routes;
